module.exports = __webpack_public_path__ + "static/img/SketchPng519ca40167a9e079b1f53f3e5549e2ad140d9fb70d4f543f896df88e561ec255.e2316aee.png";